import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import Distance145 from "./Distance145/Distance145.js";
import Distance90 from "./Distance90/Distance90.js";
import Distance70 from "./Distance70/Distance70.js";
import Distance30 from "./Distance30/Distance30.js";

const Team = () => {
  const tabs = [
    { path: "distance145", label: "145M(Kungdo)" },
    { path: "distance90", label: "90M(TarscaShild)" },
    { path: "distance70", label: "70M(Puta)" },
    { path: "distance30", label: "30M(Zamby)" },
  ];

  return (
    <>
      <Navigation
        tabs={tabs}
        basePath="/game-summary/team"
        variant="tab"
      />

      <Routes>
        <Route path="/" element={<Navigate to="distance145" replace />} />
        <Route path="distance145/" element={<Distance145 />} />
        <Route path="distance90/" element={<Distance90 />} />
        <Route path="distance70/" element={<Distance70 />} />
        <Route path="distance30/" element={<Distance30 />} />
      </Routes>
    </>
  );
};
export default Team;
